<template>
  <div class="storeTop">
    <div
      class="box"
      v-if="shopData.CompanyNameDisplayType == 1"
      :style="{
        background: shopData.BackgroundColorCode
      }"
    >
      <span
        class="text"
        :style="{
          color: shopData.CharacterColorCode
        }"
        >{{ shopData.CompanyName }}</span
      >
    </div>
    <div
      class="box"
      v-else
      :style="{
        'background-image':
          'url(' + imgUrlFilter(shopData.CompanyNameImage) + ')'
      }"
    ></div>
  </div>
</template>
<script>
export default {
  name: "StoreTop",
  props: ["shopData"],
  data() {
    return {};
  },
  methods: {
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    }
  }
};
</script>
<style lang="scss" scoped>
.storeTop {
  width: 100%;
  position: relative;
  .box {
    width: 100%;
    background-image: url("~assets/img/store/bg_1@2x.png");
    background-size: auto;
    background-position: center;
    height: 300px;
    box-shadow: 0 0 5px 0px #9b9b9b;
    .text {
      font-size: 30px;
      color: #fff;
      position: absolute;
      width: 100%;
      text-align: center;
      top: 40%;
    }
  }
}
</style>
